// extracted by mini-css-extract-plugin
export default {"GroupsListContainer":"GroupsList-module__GroupsListContainer--x6dMy","GroupItem":"GroupsList-module__GroupItem--vAFCe"};